var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessInitiatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3637 26.0007V23.637H21.2733V26.0007H2.3637ZM2.3637 2.3637V0H21.2733V2.3637H2.3637ZM11.8185 14.1822C12.8034 14.1822 13.6405 13.8375 14.3299 13.1481C15.0193 12.4586 15.364 11.6215 15.364 10.6366C15.364 9.65176 15.0193 8.81462 14.3299 8.12521C13.6405 7.4358 12.8034 7.09109 11.8185 7.09109C10.8336 7.09109 9.99647 7.4358 9.30705 8.12521C8.61764 8.81462 8.27294 9.65176 8.27294 10.6366C8.27294 11.6215 8.61764 12.4586 9.30705 13.1481C9.99647 13.8375 10.8336 14.1822 11.8185 14.1822ZM2.3637 22.4551C1.71368 22.4551 1.15723 22.2237 0.694336 21.7608C0.231445 21.2979 0 20.7414 0 20.0914V5.90924C0 5.25922 0.231445 4.70277 0.694336 4.23988C1.15723 3.77699 1.71368 3.54554 2.3637 3.54554H21.2733C21.9233 3.54554 22.4797 3.77699 22.9426 4.23988C23.4055 4.70277 23.637 5.25922 23.637 5.90924V20.0914C23.637 20.7414 23.4055 21.2979 22.9426 21.7608C22.4797 22.2237 21.9233 22.4551 21.2733 22.4551H2.3637ZM4.43193 20.0914H19.205C18.3186 18.9884 17.2451 18.1217 15.9845 17.4914C14.7239 16.861 13.3352 16.5459 11.8185 16.5459C10.3018 16.5459 8.9131 16.861 7.65247 17.4914C6.39183 18.1217 5.31832 18.9884 4.43193 20.0914Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessInitiatedIcon);
export default __webpack_public_path__ + "static/media/business-initiated-icon.0f586160599191b0badf159262b4eee0.svg";
export { ForwardRef as ReactComponent };